setValuePlanInCartB2C();

function setValuePlanInCartB2C() {
    const selectAll = (element) => document.querySelectorAll(element);
    const btnShowCartB2C = selectAll('.card-plan-b2c .addProduct');

    function setValueCart() {
        const tagValueCart = selectAll('#plan_price');
        const valueGetButton = `R$ ${this.getAttribute('data-plan-price').replace('.', ',')}/mês`;
        tagValueCart.forEach(tag => tag.innerText = valueGetButton);
    }

    btnShowCartB2C?.forEach(btn => btn.addEventListener('click', setValueCart) );
}
